<div class="layout-footer">
    <img
        src="assets/layout/images/{{
            layoutService.config().colorScheme === 'light' ? 'logo' : 'logo'
        }}.png"
        alt="Logo"
        height="20"
    />
    <span class="font-medium ml-2">UVEMA</span>
</div>
